<template>
  <!-- 注册资质 -->
  <div class="certificate">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel"
          >批量删除</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
          >新增资质证书</el-button
        >
      </template>
    </page-header>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column
        type="selection"
        align="center"
        width="55"
      ></el-table-column>
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="classify"
        show-overflow-tooltip
        label="资质分类"
      >
        {{ row.name }}
      </el-table-column>
      <el-table-column
        prop="materialName"
        align="center"
        show-overflow-tooltip
        label="证书"
      >
      </el-table-column>
      <el-table-column
        prop="customerType"
        label="角色编号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="crux"
        label="是否必填"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.crux === 'N'">否</el-tag>
          <el-tag type="success" v-if="scope.row.crux === 'Y'">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === '0'">正常</el-tag>
          <el-tag type="info" v-if="scope.row.status === '-1'">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="描述"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 添加证书 -->
    <el-dialog
      title="添加资质证书"
      :visible.sync="ceDialog"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="400px"
    >
      <el-form
        :model="ceForm"
        :rules="formRule"
        label-width="120px"
        label-position="right"
        ref="ceForm"
      >
        <el-form-item prop="type" label="资质证书">
          <el-select
            v-model="ceForm.type"
            placeholder="请选择"
            clearable
            style="width: 80%"
          >
            <el-option
              v-for="(item, index) in naturalList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="des" label="备注信息">
          <el-input
            v-model="ceForm.des"
            clearable
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item prop="des" label="是否必填">
          <el-select
            v-model="ceForm.required"
            placeholder="请选择"
            clearable
            style="width: 80%"
          >
            <el-option label="是" value="Y"></el-option>
            <el-option label="否" value="N"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button type="info" @click="resetForm">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
//混入
import { formatStatus } from "@/mixins/filters/formatStatus.js";

export default {
  name: "certificate",
  mixins: [formatStatus],
  data() {
    return {
      /**表格数据 */
      //资质分类	证书	角色编号	时间	状态	备注
      tableData: [],
      nametype: "",
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        name: "",
      },
      row: "",
      /**select选中项 */
      selectedList: [],
      naturalList: [],
      /**添加资质证书dialog */
      ceDialog: false,
      /**资质证书表单 */
      ceForm: {
        type: "",
        des: "",
        required: "Y", // 必填
      },
      formRule: {
        type: { required: true, message: "请选择类型", trigger: "blur" },
        // des: { required: true, message: "请输入备注信息", trigger: "blur" },
      },
    };
  },
  mounted() {
    let row = JSON.parse(decodeURIComponent(this.$route.query.row));
    if (row) {
      this.row = row;
      this.getTableData();
      this.getnaturalDate();
    } else {
      //执行注册
    }
  },
  methods: {
    updata() {
      if (this.row) {
        this.getTableData();
        this.getnaturalDate();
      }
    },
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },

    /**获取表格数据 */
    getTableData() {
      let data = {
        type: "PC_MaterialTypeList",
        typeid: this.row.id,
        name: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "PC_CustomerType"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "qualification/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 获取资质列表
    getnaturalDate() {
      let proc = "Proc_Admin_Category"; // 存储过程名
      let type = "ReturnList";
      let json = {
        type: "CredentialList",
        classify: "Credential",
      };
      this.$request({
        method: "post",
        url: "admin/qualification/ashx/ReturnJson.ashx",
        data: {
          type: type,
          json: JSON.stringify(json),
          proc: proc,
        },
        dataType: "json",
      }).then((res) => {
        this.naturalList = [];
        if (res.flag == 0) {
          res.data.forEach((i) => {
            this.naturalList.push({
              value: i.fdname,
              label: i.chnname,
            });
          });
        }
      });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },

    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },

    /**点击新增证书 */
    handleAdd() {
      this.ceDialog = true;
    },
    /**点击批量删除 */
    handleDel() {
      let idList = [];
      this.selectedList.forEach((i) => {
        idList.push(i.id);
      });
      idList = idList.join();
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          let data = {
            type: "PC_DelMaterialType",
            strWhere: idList,
          };
          let proc = "PC_CustomerType"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**提交绑定erp表单 */
    submitForm() {
      this.$refs["ceForm"].validate((valid) => {
        if (valid) {
          let json = {
            type: "PC_AddMaterialType",
            materialName: this.ceForm.type,
            customerType: this.row.typeid,
            CustomerTypeId: this.row.id,
            crux: this.ceForm.required,
            remark: this.ceForm.des,
          };

          let proc = "PC_CustomerType"; // 存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(json)) +
              "&proc=" +
              proc,
            dataType: "json",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.ceDialog = false;
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["ceForm"].resetFields();
      this.ceDialog = false;
    },
  },
};
</script>

<style scoped>
.certificate {
  width: 100%;
  height: 100%;
}
</style>
